import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { CmxClientLayoutComponent, LoginComponent, AuthGuard, LoginGuard } from '@cemex/cmx-client-layout';

const routes: Routes = [
  {
    path: '',
    component: CmxClientLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'app',
        pathMatch: 'full',
      },
      {
        path: 'app',
        loadChildren: () =>
          import('./launchers/ordersnproducts-launcher.module').then((m) => m.OrdersnproductsLauncherModule),
        canLoad: [AuthGuard],
      },
      {
        path: 'calendar-view',
        loadChildren: () =>
          import('./launchers/calendar-view-launcher.module').then((m) => m.CalendarViewLauncherModule),
        canLoad: [AuthGuard],
        canActivate: [],
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  { path: '**', redirectTo: 'app' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
